export default permissions =>
  !!(permissions?.admin?.xtm || permissions?.admin?.xtp)
